import { FormContextValues } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { medicalDocumentationCreateTranslationKeys } from '../../translations';

import { MedicalDocumentationCreateFormBean } from './MedicalDocumentationCreateForm.types';

const FIELD_NAME = 'includeConfidentialAnnotation';

type ConfidentialAnnotationCheckboxProps = Pick<FormContextValues<MedicalDocumentationCreateFormBean>, 'register'>;

export const ConfidentialAnnotationCheckbox = (props: ConfidentialAnnotationCheckboxProps): JSX.Element => {
   return (
      <Checkbox
         label={medicalDocumentationCreateTranslationKeys.confidentialAnnotationCheckbox}
         controller={props.register(FIELD_NAME)}
         testId={'includeConfidentialAnnotation'}
      />
   );
};
